import { InjectionToken } from '@angular/core';
import { LoadModuleReferences } from './models/load-module-reference.model';

export const LAZY_MODULE_COMPONENT_REFERENCE = new InjectionToken<LoadModuleReferences>('LAZY_MODULE_COMPONENT_REFERENCE');
